export const TEST_ID = 'formDiscardConfirmationPanel';
